import { integrationsApi } from '@carboncopyco/data';
import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { CreateDemoModal } from '../../Demo';
import { TourCaptureModals } from '../../Tour';
import { useModalActions } from '../../utils';
import { FolderPage, FolderPageArchived } from './Folders';
import { WorkspaceActiveContent } from './WorkspaceActiveContent';
import { WorkspaceArchivedContent } from './WorkspaceArchivedContent';
import { WorkspacePageProvider } from './WorkspacePageContext';
import type { WorkspacePageProps } from './WorkspacePageContext';

export const WorkspacePage = (props: WorkspacePageProps) => {
  const { modalActionsByName } = useModalActions();
  const createNewDemoModal = modalActionsByName('create-new-demo-modal');
  const createTour = modalActionsByName('create-tour-modal');
  const { pathname } = useLocation();
  const folderId = pathname.split('folder/')[1];
  const prefetchIntegrations = integrationsApi.usePrefetch('getIntegrations');
  const {
    goToDemo,
    handleOpenRecorder,
    navigateToWebTourCapture,
    handleCreateTourFromDemo,
    goToCreateOverlayDemoPage,
    organizationId,
  } = props;

  useEffect(() => {
    prefetchIntegrations({
      organizationId: Number(organizationId),
    });
  }, [organizationId, prefetchIntegrations]);

  return (
    <WorkspacePageProvider
      {...{
        ...props,
      }}
    >
      <>
        <Routes>
          <Route
            index
            element={
              <div className="flex flex-col w-full h-full overflow-y-hidden">
                <WorkspaceActiveContent />
              </div>
            }
          />
          <Route
            path="archive/folder/:folderId"
            element={
              <div className="flex flex-col w-full h-full overflow-y-hidden">
                <FolderPageArchived />
              </div>
            }
          />
          <Route
            path="folder/:folderId"
            element={
              <div className="flex flex-col w-full h-full overflow-y-hidden">
                <FolderPage />
              </div>
            }
          />
          <Route
            path="archive/*"
            element={
              <div className="flex flex-col w-full h-full overflow-y-hidden">
                <WorkspaceArchivedContent />
              </div>
            }
          />
        </Routes>
        <TourCaptureModals
          showCreateTourModal={createTour.isModalOpen()}
          hide={() => createTour.closeModal()}
          navigateToWebTourCapture={navigateToWebTourCapture}
          navigateToTourFromDemo={handleCreateTourFromDemo}
          goToDemo={goToDemo}
          handleOpenRecorder={handleOpenRecorder}
          goToCreateOverlayDemoPage={goToCreateOverlayDemoPage}
          folderId={folderId}
        />
        {createNewDemoModal.isModalOpen() && (
          <CreateDemoModal
            open={createNewDemoModal.isModalOpen()}
            onClose={() => createNewDemoModal.closeModal()}
            goToDemo={goToDemo}
            handleOpenRecorder={(workspaceId) => {
              handleOpenRecorder(workspaceId, folderId);
              createNewDemoModal.closeModal();
            }}
          />
        )}
      </>
    </WorkspacePageProvider>
  );
};
